import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { APP_CONFIG } from './config/appConfig'
import './setupAxios401'
import App from './App.jsx'

const faviconLink = document.querySelector('link[rel="icon"]')
if (faviconLink) {
  faviconLink.href = APP_CONFIG.faviconUrl
  if (APP_CONFIG.faviconUrl.endsWith('.png')) {
    faviconLink.type = 'image/png'
  } else if (
    APP_CONFIG.faviconUrl.endsWith('.jpg') ||
    APP_CONFIG.faviconUrl.endsWith('.jpeg')
  ) {
    faviconLink.type = 'image/jpeg'
  }
}
import './index.css'
import '../src/styles/global.css'
import { ThemeProvider } from '@emotion/react'
import theme from './styles/theme.js'

createRoot(document.getElementById('root')).render(
      <ThemeProvider theme={theme}>
      <App />
      </ThemeProvider>
)
